const updates = {
  tittle: `Actualizaciones Recarga-te.`,
  date: `18/10/2023`,
  descriptions: [
    `Este documento tiene el fin de explicar y ejemplificar los añadidos y actualizaciones  al sistema web de recarga-te, dichos cambios estarán presentes a partir del 18 de octubre del año en curso.`,
    `A continuación se listaran las secciones del sistema donde se presentan los cambios:`,
  ],
  sections:[
    {
      tittle: `General.`,
      children: [
        {
          description: `Se ha actualizado el menú hamburguesa para tener más espacio en la pantalla para los datos.`
        },
        {
          description: `Se han actualizado las pantallas para tener mejor distribución en dispositivos móviles.`
        },
        {
          description: `Se actualizaron los botones e iconos.`
        },
        {
          description: `Se ha añadido el nombre del usuario al inicio del menú.`
        },
        {
          description: `Se ha añadido una sección de actualizaciones donde se podrán ver todas las novedades del sistema así como todos los nuevos cambios que se vayan dando en el futuro.`
        }
      ]
    },
    {
      tittle: `Recargas.`,
      children: [
        {
          description: `Se actualizaron los botones e iconos.`
        },
        {
          description: `Se actualizó el monto máximo de recarga a $200.`
        },
        {
          description: `Se añadieron etiquetas al momento de  pasar el cursor sobre el botón.`,
          image: `update18102023-R-1.png`
        }
      ]
    },
    {
      tittle: `Usuarios.`,
      children: [
        {
          description: `Se actualizaron los botones e iconos.`
        },
        {
          description: `Se ha agregado un botón para ocultar los filtros.`
        },
        {
          description: `Se añadieron etiquetas al momento de  pasar el cursor sobre el botón.`,
          image: `update18102023-U-1.png`
        },
        {
          description: `Se actualizaron los filtros, ahora se puede agregar más de un filtro para una mejor visualización de los datos.`,
          image: `update18102023-U-2.png`
        },
        {
          description: `Se ha añadido la columna de ¨Nivel¨.`,
          image: `update18102023-U-3.png`
        },
        {
          description: `Se agregó un botón para descargar la información de los usuarios en un Excel.`,
          image: `update18102023-U-4.png`
        }
      ]
    },
    {
      tittle: `Ventas.`,
      children: [
        {
          description: `Se actualizaron los botones e iconos.`
        },
        {
          description: `Se ha agregado un botón para ocultar los filtros.`
        },
        {
          description: `Se añadieron etiquetas al momento de  pasar el cursor sobre el botón.`,
          image: `update18102023-V-1.png`
        },
        {
          description: `Se actualizaron los botones para seleccionar las fechas, ahora solo basta con hacer click en la etiqueta para abrir el selector de fechas.`,
          image: `update18102023-V-2.png`
        },
        {
          description: `Se eliminó el botón de consultar, ahora basta con seleccionar las dos  fechas para que el sistema haga la búsqueda en automático.`
        },
        {
          description: `Se restringe el rango de fechas para que no sobrepase los 93 días, esto con el fin de evitar saturar el sistema.`
        },
        {
          description: `Se añadieron las columnas de ¨Nombre recargador¨, ¨Líder recargador¨, ¨Cliente recargador¨, ¨ Líder origen¨, ¨Cliente origen¨.`,
          image: `update18102023-V-3.png`
        },
      ]
    },
    {
      tittle: `Administrar Base de datos.`,
      children: [
        {
          description: `Se actualizaron los botones e iconos.`
        },
        {
          description: `Se ha agregado un botón para ocultar los filtros.`
        },
        {
          description: `Se añadieron etiquetas al momento de  pasar el cursor sobre el botón.`,
          image: `update18102023-ABD-1.png`
        },
        {
          description: `Se actualizaron los botones para seleccionar las fechas, ahora solo basta con hacer click en la etiqueta para abrir el selector de fechas.`,
          image: `update18102023-ABD-2.png`
        },
        {
          description: `Se eliminó el botón de consultar, ahora basta con seleccionar las dos  fechas para que el sistema haga la búsqueda en automático.`
        },
        {
          description: `Se restringe el rango de fechas para que no sobrepase los 93 días, esto con el fin de evitar saturar el sistema.`
        }
      ]
    },
    {
      tittle: `Subir Archivos.`,
      children: [
        {
          description: `Se actualizaron los botones e iconos.`
        },
        {
          description: `Se agregó ayuda visual junto con  el nombre del archivo al momento de seleccionarlo, esto para tener una mayor seguridad de cual archivo se está por subir.`,
          image: `update18102023-SA-1.png`
        },
        {
          description: `Se añadió la posibilidad de subir usuarios mediante un archivo.`,
          image: `update18102023-SA-2.png`
        }
      ]
    }
  ]
}


module.exports = {
  updates
}